import { createContext, useState } from 'react';
import * as React from 'react';
import { TArticle } from '../models/common';

interface IArticleContext {
  articles: TArticle[];
  setArticles: React.Dispatch<React.SetStateAction<TArticle[]>>;
}

export const ArticleContext = createContext<IArticleContext>({
  articles: [],
  setArticles: (value: any) => undefined,
});

export const ArticleContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [articles, setArticles] = useState<TArticle[]>([]);

  return (
    <ArticleContext.Provider
      value={{
        articles,
        setArticles,
      }}
    >
      {children}
    </ArticleContext.Provider>
  );
};
